/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Specification for a rollout execution visible to a tenant.
 */
export interface RolloutTenantExecutionSpec { 
    /**
     * Allow customer to reschedule the rollout into another wave.
     */
    allow_reschedule_by_customer?: boolean;
}

